import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#123c70",
		style: { fill: "var(--color, #123c70)" },
		d: "M4 12v16c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4v-16h-24z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#123c70",
		style: { fill: "var(--color, #123c70)" },
		d: "M24 6v-4c0-1.2-0.8-2-2-2h-12c-1.2 0-2 0.8-2 2v4h-8v4h32v-4h-8zM20 6h-8v-2h8v2z"
	})]
});
export default SvgTrash;
